<template>
  <div>
    <v-card
      flat
      class="pa-3"
      :class = "this.cardClass()"
    >
      <v-card-text class="pa-0">
        <p class="title black--text">
          <mrx-translation :token="'questions.congratulations'"></mrx-translation>
        </p>
        <mrx-translation class="black--text" :token="'questions.baby_age_display.baby_age_is'"></mrx-translation>
        <div class="d-flex justify-center display-1 black--text pt-4">
          <span class="me-2">{{ $n(babyAge, 'decimal') }}</span>
          <mrx-translation :token="dayDays"></mrx-translation>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import ui from '@/mixins/ui'
  export default {
    mixins: [ui],
    name: 'duedatedisplay',
    model: {
      prop: 'items',
      event: 'click'
    },
    data() {
      return {
        babyAge: null,
        dayDays: null
      }
    },
    props: {
      'options': Object,
      'items': Array,
      'panelName': String
    },
    methods: {
      setBabyAge() {
        const deliveryDate = this.$store.getters['v4/panel/getResponse']('delivery_date', 'date')
        this.babyAge = Math.round(
          Math.abs(
            (new Date().getTime() - new Date(deliveryDate.value).getTime()) /
            (24 * 60 * 60 * 1000)
          )
        )
      },
      setDayDays() {
        this.babyAge === 1 ? this.dayDays = 'partials.time.day' : this.dayDays = 'partials.time.days'
      }
    },
    mounted() {
      this.setBabyAge()
      this.setDayDays()
      this.items[0].value = this.babyAge
      this.items[0].selected = true
    }
  }
</script>
